import React from "react";
import { SERVE_FIRST_LOGO as image__powerby_serve } from "../constants/branding";
import { useIntl } from "react-intl";
import { isServeFirstBrandingHidden } from "../helpers/serveFirstBranding";

function Footer(props) {
  const intl = useIntl();
  const hideServeFirst = isServeFirstBrandingHidden();

  return (
    <footer className="secondary-footer hide-sm">
      {!hideServeFirst ? (
        <div className="logo d-flex align-items-center justify-content-center">
          <span
            style={{
              marginRight: "15px",
              fontSize: "14px",
              color: "#FFF",
              fontWeight: "bold",
            }}
          >
            {intl.formatMessage({ id: "powered-by" })}
          </span>
          <img
            src={image__powerby_serve}
            alt="footer"
            style={{ height: "50px" }}
          />
        </div>
      ) : null}
    </footer>
  );
}
export default Footer;
